export const MINIBAT_UNLOCKED = "minibat_unlocked"
export const PROFILE_COMPLETED = "profile_completed"
export const JOBS_COMPLETED = "jobs_completed"
export const NETWORK_COMPLETED = "network_completed"
export const JOB_CREATED = "job_created"
